(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const heroes = new Map();
  const heroObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('motion-paused', !entry.isIntersecting));
  }) : null;
  const initHero = (hero) => {
    if (heroes.has(hero)) return;
    const target = hero.querySelector('[data-truck-dump-target]');
    const heading = hero.querySelector('[data-junk-heading]');
    const letters = [...hero.querySelectorAll('[data-junk-lob-letter]')];
    const cargo = [...hero.querySelectorAll('.truck-bed-letter')];
    const desktop = window.matchMedia('(min-width: 821px)');
    const controller = new AbortController();
    let frame = 0;
    let disposed = false;
    const position = () => {
      frame = 0;
      if (!target || !heading) return;
      const truck = target.getBoundingClientRect();
      const copy = hero.querySelector('.premium-hero__copy');
      const transform = copy ? getComputedStyle(copy).transform : 'none';
      const revealOffset = transform !== 'none' && 'DOMMatrixReadOnly' in window ? new DOMMatrixReadOnly(transform).m42 : 0;
      // Match the actual cargo glyph, including font scale and transform origin.
      // Read every box before writing the flight coordinates.
      const positions = letters.map((letter, index) => {
        if (!cargo[index]) return null;
        const origin = letter.parentElement.getBoundingClientRect();
        const sourceStyle = getComputedStyle(letter);
        const cargoStyle = getComputedStyle(cargo[index]);
        const scale = parseFloat(cargoStyle.fontSize) / parseFloat(sourceStyle.fontSize);
        const [originX, originY] = sourceStyle.transformOrigin.split(' ').map(parseFloat);
        const x = truck.left + parseFloat(cargoStyle.left) - origin.left - (1 - scale) * originX;
        const y = truck.top + parseFloat(cargoStyle.top) - origin.top + revealOffset - (1 - scale) * originY;
        return { x, y, tilt: cargoStyle.getPropertyValue('--bed-tilt') };
      });
      letters.forEach((letter, index) => {
        const point = positions[index];
        if (!point) return;
        const { x, y, tilt } = point;
        letter.style.setProperty('--lob-end-x', `${x}px`);
        letter.style.setProperty('--lob-end-y', `${y}px`);
        letter.style.setProperty('--lob-tilt', tilt);
        letter.style.setProperty('--lob-apex-x', `${x * 0.55}px`);
        letter.style.setProperty('--lob-apex-y', `${Math.min(-48, y * 0.3 - 150)}px`);
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(position); };
    const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    if (heading) resize?.observe(heading);
    if (target) resize?.observe(target);
    window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
    hero.addEventListener('transitionend', schedule, { signal: controller.signal });
    heroObserver?.observe(hero);
    const syncTruck = () => {
      position();
      hero.classList.toggle('allgone-truck-motion', desktop.matches && !reduced.matches);
    };
    desktop.addEventListener('change', syncTruck, { signal: controller.signal });
    reduced.addEventListener('change', syncTruck, { signal: controller.signal });
    // Font metrics determine the letter landing points. All loop animations start together.
    (document.fonts?.ready || Promise.resolve()).then(() => {
      if (disposed) return;
      syncTruck();
      hero.classList.add('allgone-hero-motion');
    });
    heroes.set(hero, () => {
      disposed = true;
      controller.abort();
      resize?.disconnect();
      heroObserver?.unobserve(hero);
      cancelAnimationFrame(frame);
      hero.classList.remove('allgone-hero-motion', 'allgone-truck-motion', 'motion-paused');
    });
  };

  const targets = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), {rootMargin:'0px 0px 32px',threshold:0.04}) : null;
  const init = (root = document) => {
    const nodes = [...(root.matches?.('[data-reveal]') ? [root] : []), ...root.querySelectorAll('[data-reveal]')];
    [...(root.matches?.('.premium-hero') ? [root] : []), ...root.querySelectorAll('.premium-hero')].forEach(initHero);
    nodes.forEach(node => { targets.add(node); if (reduced.matches || !observer) node.classList.add('is-visible'); else observer.observe(node); });
  };
  document.documentElement.dataset.motionReady='true';
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{heroes.forEach((dispose,hero)=>{if(event.target===hero||event.target.contains(hero)){dispose();heroes.delete(hero)}});targets.forEach(node=>{if(event.target.contains(node)){observer?.unobserve(node);targets.delete(node)}})});
  ['shopify:section:select','shopify:block:select'].forEach(name=>document.addEventListener(name,event=>{event.target.querySelectorAll('[data-reveal]').forEach(node=>node.classList.add('is-visible'));}));
  reduced.addEventListener('change',()=>{if(reduced.matches)targets.forEach(node=>node.classList.add('is-visible'))});
})();
